<template>
    <div class="md cart-info" :class="node.xend? 'is-closed': ''">
        <input v-if="canCheck" type="checkbox" class="checkbox" :id="'check-'+ node.cart_sn" :checked="check" :value="node.cart_sn" @change="isCheck()">
        <div class="card-content">
            <router-link
                :to="url"
                :title="productData? productData.alias || productData.product_s: ''"
                class="image"
            >
                <div v-if="node.label" class="label">{{ $siteTool.getLabelClassName(node.label) }}</div>
                <div
                    class="mask"
                    :style="{
                        'background-image': 'url('+ image +')',
                        'background-size': $siteConfig.emptyProductPhoto === image? 'contain': 'cover',
                    }"
                >
                    <img :src="node.imageurl">
                </div>
            </router-link>
            <div class="essay">
                <div class="info-area">
                    <div class="image-area">
                        <div class="image">
                            <div v-if="node.label" class="label">{{ $siteTool.getLabelClassName(node.label) }}</div>
                            <div class="mask" :style="{
                                backgroundImage: 'url('+ image +')',
                                backgroundSize: $siteConfig.emptyProductPhoto === image? 'contain': 'cover',
                            }"></div>
                        </div>
                    </div>
                    <div class="text-area">
                        <div class="caption">
                            <div class="name">
                                <span class="span">{{ node.alias || node.product_s }}</span>
                                <cpLabel
                                    v-if="productData && productData.discount && typeof setPrice === 'number'"
                                    themes="danger"
                                    :text="$t('page.product.discount', {
                                        priceType: user.ispaycash? '現金價': '票期價',
                                        allowance: productData.discount,
                                        disQty: productData.disQty || ''
                                    })"
                                ></cpLabel>
                            </div>
                            <div class="func">
                                <a v-if="editable === 'all'" href="#" @click.prevent="removeCart">{{ $t('page.shoppingcart.caption.remove') }}</a>
                                <span v-if="node.xend" href="#">{{ $t('page.shoppingcart.caption.closed') }}</span>
                            </div>
                        </div>
                        <div class="p">
                            <div class="type">{{ node.product_b }}-{{ node.product_m }}</div>
                            <div
                                class="price"
                                :class="[typeof setPrice === 'number'? '': 'is-alert']"
                            >{{ $okaTool.numberToStringFormat(setPrice) }}</div>
                        </div>
                    </div>
                </div>
                <div class="input-area">
                    <div class="input-item">
                        <label for="package">
                            {{ $t('site.noun.package') }}
                            <cpLabel
                                v-if="multipleBase"
                                themes="danger"
                                :text="$t('info.multiple', {num: multipleBase})"
                            ></cpLabel>
                        </label>
                        <div
                            v-if="editable === 'all'"
                            class="cp input select"
                            :class="[errors.has('package')? 'is-error': '']"
                            :data-error="errors.first('package')"
                        >
                            <select v-model="node.package_s" v-validate="usePackageData.length && !hasNullPackage && check? 'required|included:'+ usePackageData.map(item => item.package_s).join(','): ''" name="package">
                                <option v-if="!hasNullPackage" value="">{{ usePackageData.length? $t('site.noun.select'): $t('site.select.default') }}</option>
                                <option v-for="item in usePackageData" :key="item.package_s" :value="item.package_s">{{ item.remarks }}({{ item.package_s }})</option>
                            </select>
                        </div>
                        <div
                            v-else
                            class="input-inner"
                        ><span v-html="usePackage"></span></div>
                    </div>
                    <div class="input-item">
                        <label for="quality">{{ $t('site.noun.quality') }}</label>
                            <div v-if="editable === 'all'" class="cp input select" :class="[errors.has('quality')? 'is-error': '']" :data-error="errors.first('quality')">
                            <select v-model="node.quality" v-validate="useQualityList.length && !hasNullQuality && check? 'required|included:'+ useQualityList.map(item => item.quality).join(','): ''" name="quality">
                                <option v-if="!hasNullQuality" value="">{{ useQualityList.length? $t('site.noun.select'): $t('site.select.default') }}</option>
                                <option v-for="item in useQualityList" :key="item.quality" :value="item.quality">{{ item.remarks }}</option>
                            </select>
                        </div>
                        <div
                            v-else
                            class="input-inner"
                        ><span v-html="useQuality"></span></div>
                    </div>
                    <div class="input-item">
                        <label for="qty">
                            {{ $t('site.noun.qty') }}
                            <cpLabel
                                themes="danger"
                                :text="node.un"
                            ></cpLabel>
                        </label>
                        <div
                            v-if="editable !== 'none'"
                            class="cp input text"
                            :class="[errors.has('qty')? 'is-error': '']"
                            :data-error="errors.first('qty')"
                        >
                            <input
                                type="text"
                                v-model="node.qty"
                                v-validate="editable === 'inquiry'? (multipleBase?'multiple_of:'+ multipleBase +'|' :'') +'required|min_value: 0.01|decimal:2|max_value:'+ qtyValidate: check? (multipleBase?'multiple_of:'+ multipleBase +'|' :'') +'required|min_value: 0.01|decimal:2': ''"
                                name="qty"
                            >
                        </div>
                        <div
                            v-else
                            class="input-inner"
                        >{{ this.$okaTool.numberToStringFormat(node.qty) }}</div>
                    </div>
                    <div class="input-item">
                        <label for="customer_need_date">
                            {{ $t('site.noun.deliverydate') }}
                        </label>
                        <cpDatePicker
                            v-if="editable !== 'none'"
                            type="date"
                            :errorStatus="errors.has('customer_need_date')"
                            :errorMsg="errors.first('customer_need_date')"
                            v-model="node.customer_need_date"
                            v-validate="editable === 'inquiry'? 'required': check? 'required': ''"
                            :hideLabel="true"
                            :removeAble="false"
                            name="customer_need_date"
                            ref="customer_need_date"
                            :dayRestriction="$siteTool.dayRestriction"
                        ></cpDatePicker>
                        <div
                            v-else
                            class="input-inner"
                        ><span v-html=" node.customer_need_date || '&nbsp&nbsp &#8211;'"></span></div>
                    </div>
                    <div class="input-item">
                        <label for="outmfct">
                            {{ $t('site.noun.dispatch') }}
                        </label>
                        <div
                            v-if="editable === 'all'"
                            class="cp input select"
                            :class="[errors.has('outmfct')? 'is-error': '']"
                            :data-error="errors.first('outmfct')"
                        >
                            <select v-model="node.outmfct" v-validate="''" name="outmfct">
                                <option value="">{{ $t('site.select.defaultForOutmfct')}}</option>
                                <option v-for="item in useOutmfctData" :key="item.eqdp" :value="item.eqdp">{{ langID === 'zh'? item.orgunitname: item.outmpz }}</option>
                            </select>
                        </div>
                        <div
                            v-else
                            class="input-inner"
                        ><span v-html="useOutmfct"></span></div>
                    </div>
                </div>
                <div v-if="node.contactRemark" class="contact-label" v-html="node.contactRemark"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import cpDatePicker from '@/components/cpDatePicker'
    import cpLabel from '@/components/cpLabel'

    import { mapMutations, mapState } from 'vuex'

    export default {
        components: {
            cpDatePicker,
            cpLabel,
        },
        props: {
            node: {
                type: Object,
                require: true,
            },
            setPrice: {
                require: false,
                default: false
            },
            editable:{
                type: String,
                require: false,
                default: 'none', //all, half, none
            },
            deletable: {
                type: Boolean,
                require: false,
                default: false,
            },
            check: {
                type: Boolean,
                require: false,
                default: false,
            },
            sn: { //NAVTREE SN
                type: Number,
                require: false,
            },
            canCheck: {
                type: Boolean,
                require: false,
                default: false,
            }
        },
        data: function(){
            let _qty = this.node.qty || Infinity; //確認單上限

            return {
                qtyValidate: _qty,
            }
        },
        watch: {
            node: {
                handler: function(){
                    this.updateCart();
                },
                deep: true
            }
        },
        computed: {
            ...mapState([
                'user',
                'packageData',
                'packageMultipleData',
                'qualityList',
                'selectedDateList',
                'dispatchList',
                'langID',
            ]),
            multipleBase: function(){
                let $node = this.node,
                    _product_s = $node.product_s,
                    _package = $node.package_s;

                let _result = null;

                if( _product_s && _package ) {
                    let $target = this.packageMultipleData.find(item => item.product_s === _product_s && item.package_s === _package);

                    if( $target ) {
                        _result = $target.target_amount_multiple || 1;
                    }
                }

                return _result;
            },
            url: function(){
                let $productData = this.productData;

                if( $productData ) {
                    return '/system/productList?class='+ $productData.class[0] +'&product=all&item='+ $productData.product_sn;
                }else {
                    return '/system/productList?class=1&product=all';
                }
            },
            image: function(){
                return this.node.imageurl || this.$siteConfig.emptyProductPhoto;
            },
            productData: function() {
                return this.$siteTool.getProduct(this.node);
            },
            usePackageData: function() {
                let $result = this.$siteTool.getPackage(this.node);

                return $result.sort((a, b) => a.package_s > b.package_s ? 1 : -1);
            },
            usePackage: function(){
                let $node = this.node,
                    _package_s = $node.package_s,
                    _product_s = $node.product_s,
                    $packageData = this.packageData,
                    $target = $packageData.find(item => item.package_s === _package_s && item.product_s === _product_s);

                if( $target && $target.remarks ) {
                    return $target.remarks;
                }else if(_package_s) {
                    return _package_s;
                }else {
                    return '&nbsp;&nbsp; &#8211;';
                }
            },
            useOutmfctData: function() {
                return this.$siteTool.getOutmfct(this.node);
            },
            useOutmfct: function(){
                let $node = this.node,
                    _outmfct = $node.outmfct,
                    $dispatchList = this.dispatchList,
                    $target = $dispatchList.find(item => item.eqdp === _outmfct);

                if( $target ) {
                    return this.langID === 'zh'? $target.orgunitname: $target.outmpz;
                }else {
                    return this.$t('site.select.defaultForOutmfct');
                }
            },
            useQualityList: function() {
                return this.$siteTool.getQuality(this.node);
            },
            useQuality: function(){
                let $node = this.node,
                    _quality = $node.quality,
                    _product_s = $node.product_s,
                    $qualityList = this.qualityList,
                    $target = $qualityList.find(item => item.quality === _quality && item.product_s === _product_s);

                if( $target && $target.remarks ) {
                    return $target.remarks;
                }else if(_quality) {
                    return _quality;
                }else {
                    return '&nbsp;&nbsp; &#8211;';
                }
            },
            hasNullPackage: function(){
                return !!this.usePackageData.find(item => item.package_s === '');
            },
            hasNullQuality: function(){
                return !!this.useQualityList.find(item => item.quality === '');
            },
        },
        methods: {
            ...mapMutations([
                'pushToolTip',
                'pushPopUp',
            ]),
            showPopUp: function(evt, str){
                
                this.pushPopUp({
                    type: 'alert',
                    content: {
                        html: str
                    },
                })
            },
            showToolTip: function(evt, str){
                
                this.pushToolTip({
                    type: 'toolTip',
                    event: evt,
                    content: {
                        html: str
                    },
                    pointerEvents: 'none'
                })
            },
            isCheck: function() {
                this.$emit('sendEvent', 'tagChange', this.sn , this.check);
            },
            validate: function() {
                return this.$validator.validate().then(result => {
                    return result;
                });
            },
            updateCart: function(){
                this.$emit('sendEvent', 'updateCart', this.node);
            },
            removeCart: function(){
                this.$emit('sendEvent', 'removeCart', this.node);
            },
            viewItem: function(item){
                let $data = item;

                window.dataLayer = window.dataLayer || [];
                dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                dataLayer.push({
                    event: "view_item",
                    ecommerce: {
                        currency: "TWD",
                        value: $data.price,
                        items: [
                            {
                                item_id: $data.product_sn,
                                item_name: $data.product_s,
                                item_brand: "Formosa Plastic Corporation",
                                item_category: $data.product_b,
                                item_category2: $data.product_m,
                                item_category3: $data.product_s,
                            }
                        ]
                    }
                });
            }
        },
    }
</script>

<style scoped lang="scss">

    .md.cart-info {
        display: flex;

        &.is-closed {
            opacity: $opacity-m;
        }

        .is-unmarket & {
            opacity: $opacity-m;

            .checkbox {
                pointer-events: none;
            }
        }

        .checkbox {
            align-self: center;
            margin-right: $interval-m;
            flex-shrink: 0;

            @include media('mobile') {
                align-self: start;
            }
        }

        .card-content {
            display: flex;
            flex: 1;
        }

        .image {
            width: 224px;
            position: relative;
                    
            @include media('mobile') {
                display: none;
            }

            .label {
                position: absolute;
                top: $interval-s;
                left: $interval-s;
                padding-bottom: 25%;
                background-color: $tag-color;
                padding: $interval-xs $interval-s;
                font-size: $font-size-s;
                border-radius: $border-radius;
                color: $white;
                text-shadow: 1px 1px 2px $gray;
                font-weight: 900;
                z-index: 1;
                // border: $border;
                // border-color: $minor-color;
                // background-size: contain;
                // background-position: center;
                // background-repeat: no-repeat;
                // text-shadow: 1px 1px 2px $gray;
                // white-space: nowrap;

                // &.spec {
                //     background-image: image-url('spec.png');
                // }

                // &.hot {
                //     background-image: image-url('hot.png');
                // }

                // &.new {
                //     background-image: image-url('new.png');
                // }

                // &.sale {
                //     background-image: image-url('sale.png');
                // }
            }

            .mask {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
                background-color: $light;
                border-radius: $border-radius;
            }

            img {
                display: none;
            }
        }

        .essay {
            padding-left: $interval-m;
            flex: 1;
                    
            @include media('phone') {
                padding-left: 0;
            }

            .info-area {

                @include media('mobile') {
                    display: flex;
                    padding-bottom: $interval-m;
                }
            }

            .image-area {
                display: none;

                @include media('mobile') {
                    display: block;
                }

                .image {
                    width: 120px;
                    padding-bottom: 100px;
                    
                    @include media('mobile') {
                        display: block;
                    }
                }
            }

            .text-area {

                @include media('mobile') {
                    flex: 1;
                    padding-left: $interval-m;
                }
            }

            .caption {
                display: flex;
                padding: $interval-xs 0;

                .name {
                    flex: 1;
                    display: flex;
                    align-items: center;

                    .span {
                        font-weight: bold;

                        + span {

                            @include media('phone') {
                                display: none;
                            }
                        }
                    }
                }

                .func {

                    a {
                        transition: $transition;
                        color: $major-color;

                        &:hover {
                            opacity: $opacity-m;
                        }

                        &::before {
                            content: '\e92e';
                            @extend %font-pseudo;
                            font-size: $font-size-xxl;
                        }
                    }
                }
            }

            .p {
                padding: $interval-xs 0;
                display: flex;

                @include media('mobile') {
                    display: block;
                }

                .type {
                    flex: 1;
                }

                .price {
                    font-weight: bold;

                    &::before {
                        content: 'NT$ ';
                    }

                    &.is-alert {

                        &::before {
                            $type: map-get($colors, 'danger');
                            $text: map-get($type, 'text');

                            @extend %font-pseudo;
                            position: relative;
                            content: '\e001';
                            margin-right: $interval-xs;
                            color: $text;
                            vertical-align: bottom;
                        }
                    }
                }
            }

            .input-area {
                padding: $interval-s;
                background-color: $light;
                border-radius: $border-radius;
                display: flow-root;

                %formater {
                    $type: map-get($colors, 'danger');
                    $text: map-get($type, 'text');

                    color: $text;

                    &.is-alert {

                        &::before {
                            $type: map-get($colors, 'danger');
                            $text: map-get($type, 'text');

                            @extend %font-pseudo;
                            vertical-align: middle;
                            margin-right: $interval-s;
                            position: relative;
                            margin-right: $interval-xs;
                            color: $text;
                        }
                    }
                }

                .input-item {
                    box-sizing: border-box;
                    float: left;
                    width: 33.3%;
                    padding: 0 $interval-xs;
                    
                    @include media('mobile') {
                        width: 50%;
                    }

                    label {
                        display: block;
                        padding: $interval-s;

                        .extend {
                            @extend %formater;
                            font-size: $font-size-xxl;

                            &.is-alert {

                                &::before {
                                    content: '\e001';
                                }
                            }
                        }
                    }

                    .cp.input {
                        width: auto;
                        box-sizing: border-box;
                    }
                }

                .input-inner {
                    padding-top: $interval-s;
                }
            }
        }
    }

    .contact-label {
        $type: map-get($colors, 'warninglight');
        $text: map-get($type, 'text');
        $background: map-get($type, 'background');
        $border: map-get($type, 'border');

        border: $border;
        background-color: $background;
        color: $text;
        margin-top: $interval-s;
        padding: $interval-xs $interval-s;
        font-size: $font-size-s;
    }
</style>
